// extracted by css-extract-rspack-plugin
export default {"screen":"screen-pVUkiV","img":"img-fMZ3nf","title":"title-yfVbLN"};